import { IEventMarketCornersGoalFromWS } from '@/types/event';
import { BetSelection } from '@/constants';
import { AbstractMarket } from '@/models/abstractMarket';

export class MarketCornersGoalItem extends AbstractMarket {
    public handicap: string;
    public overPrice: string | null;
    public underPrice: string | null;
    public overBookmakerId: number | null;
    public underBookmakerId: number | null;
    public overPriceList: [number, number][] | null;
    public underPriceList: [number, number][] | null;
    public feedCount: number;
    public marginPerc: string | null;

    constructor(data: IEventMarketCornersGoalFromWS) {
        super();

        this.setPreviousPrice(BetSelection.CornersGoalOver, data.price_over_max);
        this.setPreviousPrice(BetSelection.CornersGoalUnder, data.price_under_max);

        this.overPrice = data.price_over_max;
        this.underPrice = data.price_under_max;
        this.overBookmakerId = data.price_over_max_site_id;
        this.underBookmakerId = data.price_under_max_site_id;
        this.overPriceList = data.price_over_list ? JSON.parse(data.price_over_list) : null;
        this.underPriceList = data.price_under_list ? JSON.parse(data.price_under_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }

    public update(data: IEventMarketCornersGoalFromWS) {
        this.setPreviousPrice(BetSelection.CornersGoalOver, this.overPrice);
        this.setPreviousPrice(BetSelection.CornersGoalUnder, this.underPrice);

        this.overPrice = data.price_over_max;
        this.underPrice = data.price_under_max;
        this.overBookmakerId = data.price_over_max_site_id;
        this.underBookmakerId = data.price_under_max_site_id;
        this.overPriceList = data.price_over_list ? JSON.parse(data.price_over_list) : null;
        this.underPriceList = data.price_under_list ? JSON.parse(data.price_under_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }
}
